import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/retry.svg';

export const IconRetry = createIconComponent(Icon);
